import script from "./PopOverNoteItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PopOverNoteItem.vue?vue&type=script&setup=true&lang=js"

import "./PopOverNoteItem.vue?vue&type=style&index=0&id=1fe4da1a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fe4da1a"]])

export default __exports__